import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { S3BucketIntegrationRecord } from "../S3BucketIntegrationRecord";

export const getQueryKey = (orgId?: string) => {
  if (orgId === undefined) {
    return ["s3BucketIntegrations"];
  }

  return ["s3BucketIntegrations", orgId];
};

export function useS3BucketIntegrations(orgId?: string) {
  const { integrationService } = useDomainServices();

  return useQuery<S3BucketIntegrationRecord[], Error>({
    queryKey: getQueryKey(orgId),
    queryFn: async ({ signal }) => {
      if (orgId === undefined) {
        throw new Error("Invalid orgId");
      }

      const data = await integrationService.listS3BucketIntegrations(orgId, {
        abortSignal: signal,
      });

      return data.items;
    },
    enabled: orgId !== undefined,
    staleTime: 60000,
  });
}
